/* ==================================================
#Featured collection
#Featured promotions
#Slideshow
#Testimonials
#Gallery
#Video
#Cart
#Minicart
#Product
#Header
#Social media
#Map
#FAQ

/*============================================================================
  Featured collection
==============================================================================*/

var featuredCollectionSection = {
  init: function(){
    $('.js-product-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "cellAlign": cellAlign,
        "pageDots": usePageDots,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });

      $(this).addClass('slider-initialized');
    });
  },
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    if ($slider.hasClass('flickity-enabled')){
      $slider.flickity('destroy');
    }
  }
}

/*============================================================================
  Featured promotions
==============================================================================*/
var featuredPromotions = {
  init: function(){
    if ($(window).width() > 798 || $(window).width() == 0) {
      $('.feature-overlay').hover(function(){
        $(this).find('.feature-details').slideDown('100', function(){
          $(this).addClass('reveal-details');
        });
      }, function(){
        $(this).find('.feature-details').removeClass('reveal-details');
        $(this).find('.feature-details').slideUp('100');
      });

      $('.js-featured-promotions').each(function (index, value){
        var $promos = $(this);
        var animationStyle = $(this).data('promo-animation');

        $promos.waypoint(function() {
          $(this.element).find(".feature-section").addClass("animated " + animationStyle);
        }, { offset: '80%' });
      });
    }
  }
}

/*============================================================================
  Slideshow
==============================================================================*/

var slideshow = {
  init: function(){

    $('.js-homepage-slideshow').each(function (index, value){
      var $homepageSlider = $(this);
      var settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
        adaptiveHeight: $homepageSlider.data('adaptive-height')
      }

      //initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')){
        var arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
                    adaptiveHeight: settings.adaptiveHeight,
                    wrapAround: true,
                    cellAlign: 'left',
                    imagesLoaded: true,
                    prevNextButtons: arrowShow,
                    draggable: arrowShow,
                    pageDots: usePageDots,
                    autoPlay: settings.slideshowSpeed,
                    arrowShape: arrowSize
                  });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $homepageSlider.data('flickity');
          setTimeout(function() {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $homepageSlider.on( 'select.flickity', function() {
            if($homepageSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $homepageSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $homepageSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }

      $homepageSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.btn_primary').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.btn_primary').width(buttonWidth);
      });

    });
  },
  unload: function($target){

    var $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Testimonials
==============================================================================*/

var testimonial = {
  init: function(){

    $('.js-testimonial').each(function (index, value){
      var $testimonialSlider = $(this);
      var settings = {
        slideshowSpeed: $testimonialSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $testimonialSlider.data('slideshow-text-animation')
      }

      if( $('.testimonial-image').length > 0){
        $('.testimonial-block').each(function(){
          if( $(this).find('.testimonial-image').length == 0){
            var theBlock = $(this).closest('.testimonial-block');
            $(theBlock).addClass('set-testimonial-height');
          }
        })
      }

      //initiate the slideshow
      if (!$testimonialSlider.hasClass('flickity-enabled')){
        var arrowShow = $testimonialSlider.find('.gallery-cell').length === 1 ? false : true;
        $testimonialSlider.flickity({
                        wrapAround: true,
                        cellAlign: 'left',
                        imagesLoaded: true,
                        prevNextButtons: arrowShow,
                        draggable: arrowShow,
                        pageDots: usePageDots,
                        autoPlay: settings.slideshowSpeed,
                        arrowShape: arrowSize
                      });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $testimonialSlider.data('flickity');
          setTimeout(function() {
            $testimonialSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $testimonialSlider.on( 'select.flickity', function() {
            if($testimonialSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $testimonialSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $testimonialSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find('.gallery-cell').length > 1) {
        $testimonialSlider.addClass('multi-image');
      } else {
        $testimonialSlider.addClass('single-image');
      }

      $testimonialSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.btn_primary').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.btn_primary').width(buttonWidth);
      });

    });
  },

  unload: function($target){
    var $slider = $target.find('.js-testimonial');

    $slider.flickity('destroy');

  }
}

/*============================================================================
  Gallery
==============================================================================*/

var gallery = {
  init: function(){

    $('.gallery-horizontal').find('.gallery-image-wrapper').each(function(){
      var wrapper = $(this);
      var images = $(this).find("img");
      var imgWidth,
          imgHeight;

      $("<img />").attr("src", $(images).attr("src")).on('load', function() {
        imgWidth = this.width;
        imgHeight = this.height;

        $(wrapper).css("flex-basis", imgWidth * 200 / imgHeight);
        $(wrapper).css("flex-grow", imgWidth * 200 / imgHeight);
        $(wrapper).find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    });
  });

  $('[rel=gallery]').fancybox({
    baseClass: "gallery-section__lightbox",
    clickContent: "nextOrClose"
  })

  }
}

/*============================================================================
  Video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  init: function(){

    //Initialize lazy videos
    lazyframe('.lazyvideo--autoplay--true', {
      initinview: true,
    });

    lazyframe('.lazyvideo--autoplay--false', {
      initinview: false,
    });

    lazyframe('.lazyvideo--product-video');

    //Wrap product description iframes in responsive lazyframe div
    $('.product_section .description').find('iframe').wrap('<div class="lazyframe" data-ratio="16:9"></div>');



    function hideTextElements(parent) {
      parent.find('.caption').hide();
      parent.find('.btn_primary').hide();
    }

    var videoElement = $('.js-video.hide-text-on-video.video-autoplay--true').parents('.js-video-section');
    hideTextElements(videoElement);


    if($('.js-video').hasClass('hide-text-on-video') && $('.js-video').hasClass('video-autoplay--true')){
      var videoSection = $('.js-video').parents('.js-video-section');
      hideTextElements(videoSection);
    }

    $(".video-section .lazyvideo.hide-text-on-video").on('click', function(){
      var videoSection = $(this).parents('.js-video-section');
      hideTextElements(videoSection);
    })

    $('[data-play-video-button], video.hide-text-on-video, .lazyvideo--autoplay--false').on('click', function(){
      //Target parent lazyframe
      var videoSection = $(this).parents('.js-video-section');
      var lazyElement = videoSection.find('.lazyframe');
      var videoWrapper = videoSection.find('.js-video');
      if(videoWrapper.data('mp4') || videoWrapper.data('ogv')) {
        videoSection.find('video')[0].play();
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      } else{
        //create iframe and add settings
        var lazyIframe = document.createElement('iframe');
        iframeSrc = lazyElement.data('src');
        cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf('?')) + '?&autoplay=1';
        lazyIframe.src = cleanIframeSrc;
        lazyIframe.setAttribute('allowfullscreen', true);
        lazyIframe.setAttribute('frameborder', 0);
        //Append iframe to lazyframe
        lazyElement.append(lazyIframe);
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      }
    });
  },
  unload: function($target){
    $target.find('[data-play-video]').off('click');
    $target.find('video.hide-text-on-video').off('click');
  }
}

/*============================================================================
  Cart
==============================================================================*/
var cart = {
  init: function(){
    if ($('#cart_form .tos_agree').length) {
      //Terms of service on cart page
      const termsOfServiceElements = $('.tos_agree');
      termsOfServiceElements.on('change', function() {
        // When one .tos_agree becomes checked, check the other one too
        if ($(this).is(':checked')) {
          termsOfServiceElements.prop('checked', true);
        } else {
          termsOfServiceElements.prop('checked', false);
        }
      });
      
      $('body').on('click', "#cart_form input[type='submit']", function() {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + "Debe aceptar los términos y condiciones para pagar." + '</p>';
          if ($('p.warning').length == 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }

    //Refresh page on add to cart if on cart page
    if($('body').hasClass('cart')) {
      $('.product_form form').on("submit", function(){
        setTimeout(function(){
          document.location.href = "/cart";
        }, 500);
      });
    }
  }
}

/*============================================================================
  Minicart
==============================================================================*/
const minicart = {
  handleInteractivity: function(shouldEnable) {
    const minicartElements = document.querySelectorAll('.mini_cart');
    minicartElements.forEach((currentEl) => {
        if(currentEl){
            const disabledString = "disabled";
            if(shouldEnable){
                currentEl.removeAttribute(disabledString);
                currentEl.classList.remove(disabledString);
            } else {
                currentEl.setAttribute(disabledString, "");
                currentEl.classList.add(disabledString);
            }
        }               
    })
  },
}

/*============================================================================
  Product
==============================================================================*/

selectCallback = function(variant, selector) {




  // Updates sku on Product Details Page
  $('.product_code__sku').text(variant.sku);

  GTM.variant_sku = variant.sku;
  GTM.variant_name = variant.title;

  // Updates data for variant limitation on buy
  if(typeof window.variantMaxQty !== 'undefined'){
      for(i in variantMaxQty){
          var el = variantMaxQty[i];
          if(el.id == variant.id){
            $('.max-qty-alert b').html(el.max);
            $('input[name="properties[max]"]').val(el.max);
            break;
          }
      }
  }

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form, .shopify-product-form', $product);
  var variantInventory = $productForm.data('variant-inventory');
  var $notifyFormInputs = $('.notify_form__inputs');

  var notifyEmail = "Ingresa tu correo electrónico…";
  var notifyEmailValue = "";
  var notifySend = "Enviar";

  var notifyUrl = $notifyFormInputs.data('url');
  var notifyMessage = "Por favor, notifícame cuando "+variant.title+" esté disponible- "+notifyUrl;

  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = "";
    var notifyEmailInput = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="'+ notifyCustomerEmail +'" />'
  } else {
    var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="'+ notifyEmail +'" value="'+ notifyEmailValue +'" />';
  }
  var notifyFormHTML = notifyEmailInput+'<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="'+ notifyMessage +'" value="'+ notifyMessage +'" /><input class="btn_primary cta-width" type="submit" value="'+ notifySend + '" style="margin-bottom:0px" />';

  //Image Variant feature
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.js-product-gallery, .js-gallery-modal', $product);
    $sliders.each(function() {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined ) {
        if ($slider.hasClass('new-product_gallery')) {
          var index = $('[data-image-id="' + variant.featured_media.id + '"]').data('index');
        }else {
          var index = $('[data-image-id="' + variant.featured_image.id + '"]').data('index');
        }
        $sliderInstance.select( index, false, true );
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function(v){
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);
    
  }

  if (variant && variant.available == true) {

    if(variant.price < variant.compare_at_price){
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.savings', $product).html("Tu ahorro" + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
      $('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
      
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    if (variant.price > 0) {
      $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
    } else {
      $('.current_price', $product).html("Free");
    }
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).show();
    $notify_form.hide();
    $notifyFormInputs.empty();

    // If product variable is availabe show quantity selector and sticky bar
    $('.add_to_cart .text').text('Añadir al carrito');
    // $('.product-buy-info .product-quantity-box').css({opacity:1});
    // $('.btn-to-cart').css({opacity:1});

} else {

    // If product variant is not available hides quantity selector and sticky bar
    $('.add_to_cart .text').text('');
    // $('.product-buy-info .product-quantity-box').css({opacity:0});
    // $('.btn-to-cart').css({opacity:0});

    var message = variant ? "Próximamente en stock" : "Próximamente en stock";
    $('.was_price', $product).text('');
    $('.savings', $product).text('');
    $('.current_price', $product).text('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.text', $product).text(message);
    $('.sold_out', $product).text('');
    // $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('.current_price').text(message);
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled');
    $('.shopify-payment-button', $product).hide();
    $notify_form.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }


  if(typeof productToJson === 'object'){
    // If product is not available hides the whole variants block and the skticky bar
    $('.product-sticky-form').toggle(productToJson.available);
    $('.product-buy-info').toggle(productToJson.available);
  }


  
};

var productPage = {
  init: function(){

    var draggable = true;
    var prevNextButtons = true;
    var $productGallery = $('.js-product-gallery');
    var $productGalleryNavWrapper = $('.new_gallery_nav_wrapper');
    var autoplay = $productGallery.data('autoplay');

    setTimeout(function(){
     imageFunctions.linkGalleryAndCarousel($('.js-product-page-gallery .js-product-gallery'), $('.js-product-page-gallery .product_gallery_nav'));
    }, 1000);

    if($('.js-full-width-product-images').length){
      imageFunctions.fullWidth('.product-template .product .description img', '.js-full-width-product-images');
    }

    if ($productGallery.hasClass('single-image')){
      draggable = false;
      prevNextButtons = false;
    }

    if(is_touch_device() && $productGallery.hasClass('popup-enabled--false')) {
      imageFunctions.zoom('.js-product-gallery');
      draggable = false;
    } else {
      imageFunctions.zoom('.js-product-gallery', false);
    }

    $productGallery.removeClass('loading');
    if ($productGallery[0]) {
      $productGallery[0].offsetHeight;
    }

    $productGalleryNavWrapper.removeClass('hidden');

    $productGallery.flickity({
      "adaptiveHeight": true,
      "wrapAround": true,
      "cellAlign": "left",
      "draggable": draggable,
      "contain": true,
      "imagesLoaded": true,
      "lazyLoad": 2,
      "pageDots": false,
      "prevNextButtons": prevNextButtons,
      "autoPlay": autoplay ? 6000 : false,
      "dragThreshold": 10,
      "arrowShape": arrowSize
    });

    // Badges resize PDP 2.0
    const $prodCell = $('.product-container .js-product-gallery');

    if ($prodCell.length) {
      const $badge = $prodCell.closest('.product-media-wrap').find('.badges-list');

      if ($badge.length) {
        const $prodImage = $prodCell.find('.gallery-cell .lightbox .image__container img');

        function updateBadgePosition() {
          const cellWidth = $prodCell.width();
          const imageWidth = $prodImage.width();
          const marginLeft = parseFloat($prodImage.css('margin-left'), 10);

          const imageLeftPosition = Math.min(0, (cellWidth - imageWidth) / 2);
          const isMobile = window.matchMedia('(max-width: 798px)').matches;
          const padding = isMobile ? 10 : 15;

          const newLeftPosition = imageLeftPosition + padding + marginLeft;
          $badge.css('left', `${newLeftPosition}px`);
          $badge.removeClass('hide');
        }

        document.addEventListener('DOMContentLoaded', updateBadgePosition);
        updateBadgePosition();

        let resizeTimeout;
        $(window).on('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(updateBadgePosition, 100);
        });
      }
    }

    var groupCells = true;
    var navPrevNextButtons = false;
    var navCellAlign = "center";
    var navWrapAround = false;

    if ($('.product_gallery_nav .gallery-cell').length >= 7) {
      groupCells = false;
      navPrevNextButtons = true;
      navCellAlign = "left";
      navWrapAround = true;
    }

    //Vars for Nav slider product 2.0
    var productGallery = ".product_gallery";
    var navContain = false;
    var navWrap = false;

    if( $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').hasClass('js-slider-control')) {
      productGallery = ".js-product-gallery.js-slider-controlled";
      navWrapAround = false;
      navContain = true;
      navWrap = true;
    }
    $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').flickity({
      "asNavFor": productGallery,
      "adaptiveHeight": false,
      "wrapAround": navWrapAround,
      "cellAlign": "center",
      "draggable": true,
      "groupCells": groupCells,
      "prevNextButtons":  navPrevNextButtons,
      "pageDots": false,
      "lazyLoad": 2,
      "dragThreshold": 10,
      "arrowShape": arrowSize,
      "contain" : navContain,
      "isWrapped" : navWrap,
    });

    //Handle scroll for both sliders product 2.0
    // previous
    if ($productGallery.hasClass('single-image')) {
      if($('.button-row')) {
        $('.button-row').hide();
      }
    } else {
      // previous
      $('.button-row .button--previous').on( 'click', function() {
        $('.js-product-gallery.js-slider-controlled').flickity('previous' ,true);
      });
      // next
      $('.button-row .button--next').on( 'click', function() {
        $('.js-product-gallery.js-slider-controlled').flickity( 'next', true );
      });
    }

    $(".js-product_section .product_form_options").each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html("¡Gracias! ¡Te notificaremos cuando este producto esté disponible!");
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("¡Gracias! ¡Te notificaremos cuando este producto esté disponible!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    

    $('.js-product-gallery a').fancybox({
      baseClass: "product-section__lightbox",
      clickContent: false,
      afterShow: function(instance, slide) {
        const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
        if (zoom){
          $('.fancybox-image')
              .wrap('<span class="zoom-wrap" style="display:inline-block"></span>')
              .css('display', 'block')
              .parent()
              .zoom({
                touch: false,
                magnify: 1
          });
        }
      },
      afterClose: function(instance, slide) {
        const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
        $instanceGallery.hide();
        setTimeout(function(){
          $instanceGallery.fadeIn(100);
        }, 1);
      }
    })

  },
  productSwatches: function(){
    //Swatches linked with selected options
    
  },
  relatedProducts: function(){

    $('.js-related-products-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "cellAlign": cellAlign,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "pageDots": usePageDots,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });
    });
  },
  initializeQuantityBox: function() {

    $('body').on('click', '.js-change-quantity', function () {
      var $this = $(this),
          $form = $this.parents('form'),
          $input,
          product;
      if ($(this).parents('.product_form').length) {
          $input = $('input.quantity', $form);
      } else {
        $input = $(this).siblings('input');
      }

      var val = parseInt($input.val()),
        valMax = 100000000000000000000000000000,
        valMin = $input.attr('min') || 0;


      if ($input.attr('max') != null) {
        valMax = $input.attr('max');
      }

      if (isNaN(val) || val < valMin) {
        $input.val(valMin);
        return false;
      } else if (val > valMax) {
        $input.val(valMax);
        return false;
      }

      if ($this.data('func') == 'plus') {
        if (val < valMax) $input.val(val + 1);
        if (val + 1 > 0) {
          $('.product-minus', $form).removeClass('limit');

          $("#plus", $form).removeClass("current");

          $(this).addClass("current");
          var product_info_json = $(".current", $form).attr("data-json");

          if (typeof product_info_json !== 'undefined') {
            product = JSON.parse(product_info_json);
          }

          function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          }

          var product_name = this.getAttribute('product-name');
          var product_id = this.getAttribute('product-id');
          var product_price = this.getAttribute('product-price');
          var product_brand = this.getAttribute('product-brand');
          var product_type = this.getAttribute('product-type');
          var product_size = this.getAttribute('product-size');
          var position = this.getAttribute('position');

          $(".icon-plus", $form).removeClass("current");
          $(this).addClass("current");

          if(typeof dataLayer == 'object' && $form.hasClass('js-cart_content__form')){
              dataLayer.push({
                  'event': 'addToCart',
                  'ss_event_id': GTM.getGtmRandomString(),
                  'ecommerce': {
                  'currencyCode': GTM.currency_code,
                  'add': {
                      'actionField': {
                      'list': 'cart'
                      },
                      'products': [{
                      'name': GTM.formatString(product_name),
                      'id': product_id,
                      'price': product_price/100,
                      'brand': GTM.formatString(product_brand),
                      'category': GTM.formatString(product_type),
                      'variant': GTM.formatString(product_size),
                      'quantity': 1
                      }]
                  }
                  }
              });
          }

        }

      } else {
        if (val > valMin) $input.val(val - 1);

        if (val - 1 == valMin || val - 1 == 0) {
          $('.product-minus', $form).addClass('limit');
            // If quantity is set to 0, open cart modal
            if (val - 1 == 0) {
              var $modal = $('#cartModal');
              $modal.modal('show');
              $modal.data('targetInput', $input);
              $modal.data('productMinus', $this);
              $modal.data('originalValue', val);  // Save original val

              return false; // Block the flow until removal is confirmed
            }

          function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          }

          var product_name = this.getAttribute('product-name');
          var product_id = this.getAttribute('product-id');
          var product_price = this.getAttribute('product-price');
          var product_brand = this.getAttribute('product-brand');
          var product_type = this.getAttribute('product-type');
          var product_size = this.getAttribute('product-size');
          var position = this.getAttribute('position');

          $(".icon-minus", $form).removeClass("current");
          $(this).addClass("current");

          if(typeof dataLayer == 'object' && $form.hasClass('js-cart_content__form')){
            dataLayer.push({
                'event': 'removeFromCart',
                'ss_event_id': GTM.getGtmRandomString(),
                'ecommerce': {
                'currencyCode': GTM.currency_code,
                'remove': {
                    'actionField': {
                    'list': 'cart'
                    },
                    'products': [{
                    'name': GTM.formatString(product_name),
                    'id': product_id,
                    'price': product_price/100,
                    'brand': GTM.formatString(product_brand),
                    'category': GTM.formatString(product_type),
                    'variant': GTM.formatString(product_size),
                    'quantity': 1
                    }]
                }
                }
            });
          }

        } else {

          $('.product-minus', $form).removeClass('limit');

          $("#minus", $form).removeClass("current");
          $(this).addClass("current");

          var product_info_json = $(".current").attr("data-json");
          if (typeof product_info_json !== 'undefined') {
            product = JSON.parse(product_info_json);
          }

          function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          }

          var product_name = this.getAttribute('product-name');
          var product_id = this.getAttribute('product-id');
          var product_price = this.getAttribute('product-price');
          var product_brand = this.getAttribute('product-brand');
          var product_type = this.getAttribute('product-type');
          var product_size = this.getAttribute('product-size');
          var position = this.getAttribute('position');

          $(".icon-minus", $form).removeClass("current");
          $(this).addClass("current");

          if(typeof dataLayer == 'object' && $form.hasClass('js-cart_content__form')){
            dataLayer.push({
                'event': 'removeFromCart',
                'ss_event_id': GTM.getGtmRandomString(),
                'ecommerce': {
                'currencyCode': GTM.currency_code,
                'remove': {
                    'actionField': {
                    'list': 'cart'
                    },
                    'products': [{
                    'name': GTM.formatString(product_name),
                    'id': product_id,
                    'price': product_price/100,
                    'brand': GTM.formatString(product_brand),
                    'category': GTM.formatString(product_type),
                    'variant': GTM.formatString(product_size),
                    'quantity': 1
                    }]
                }
                }
            });
          }

        }

        if ($this.parents(".cart_item").length) {
          if (val - 1 == 0) {
            $this.closest('.cart_item').addClass('animated fadeOutUp');
          }
        }

      }
      $input.trigger('change');
    });

    //Open modal from cart item button
    $('body').on('click', '.remove-product', function () {
      var $this = $(this),
          $form = $this.parents('form'),
          $input = $this.closest('.cart_item').find('input.quantity', $form),
          $modal = $('#cartModal');

      var val = parseInt($input.val()) || 0;

      $modal.modal('show');
      
      $modal.attr('tabindex', 0);
      $modal.data('targetInput', $input);
      $modal.data('originalValue', val);
      $modal.data('productRemoveButton', $this);
      $modal.data('productMinus', $this.closest('.cart_item').find('.product-minus'));
      $modal.data('action', 'remove-product');

      window.trapFocus && window.trapFocus($modal[0]);

      return false;
    });

    // Confirm product removal
    $('body').on('click', '.remove-product-confirm', function () {
    var $modal = $('#cartModal'),
        $productRemove = $modal.data('productRemoveButton');


      if ($productRemove && $productRemove.hasClass('remove-sachet-cart_item')) {
        // If sachet: find input and trigger change
        var $input = $('.dav-cart .sachet_list li input[data-variant_id="' + $productRemove.data('variant_id') + '"]');
        if ($input.length) {
          $input.prop('checked', false).trigger('change');
        }

        var $inputMinicart = $('.dav-minicart .sachet_list li input[data-variant_id="' + $productRemove.data('variant_id') + '"]');
        if ($inputMinicart.length) {
          $inputMinicart.prop('checked', false).trigger('change');
        }
      } else {
        //handle removal normal product
        var $input = $modal.data('targetInput'),
            $productMinus = $modal.data('productMinus');

        if ($input && $productMinus) {
            $input.val(0).trigger('change');

            if ($productMinus.parents(".cart_item").length) {
              $productMinus.closest('.cart_item').addClass('animated fadeOutUp');
            }
        }
      }

      $modal.attr('tabindex', -1);
      $modal.modal('hide');

      window.removeTrapFocus && window.removeTrapFocus($modal[0]);

      const $closeMinicart = $('.cart_container.active_link .minicart_close');
      const $formMinicart = $('.cart_container.active_link .js-cart_content__form');
      const $topCart = $('.cart_image-wrapper')
      const $formCart = $('.cart_container-new');


      setTimeout(() => {
        
        window.trapFocus && $formMinicart.length && window.trapFocus($formMinicart[0]);
        if($closeMinicart.length) $closeMinicart[$closeMinicart.length-1].focus(); 
        
        window.trapFocus && $formCart.length && window.trapFocus($formCart[0]);
        if($topCart.length) $topCart[0].focus(); 
      }, 100);


    });

    // Dismiss product removal
    $('body').on('click', '.remove-product-dismiss', function (e) {

      var $modal = $('#cartModal'),
          $input = $modal.data('targetInput');

      window.removeTrapFocus && window.removeTrapFocus($modal[0]);
      $modal.attr('tabindex', -1);

      if ($input) {
        var originalValue = $modal.data('originalValue');
        $input.val(originalValue); // Reset to original quantity
      }


      const $formMinicart = $('.cart_container.active_link .js-cart_content__form');

      setTimeout(() => {
        window.trapFocus && $formMinicart.length && window.trapFocus($formMinicart[0]);
        if($modal.data('productRemoveButton').length) $modal.data('productRemoveButton')[0].focus();
      }, 100);

    });

  },
  unload: function($target){

    var $slider = $target.find('.products-slider');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Header
==============================================================================*/

var header = {
  productStickyMobileInitialized:false,
  init: function(){

    $('.search-terms').on('keydown',function(){
        var $el = $(this);
        var text = $el.val();

        $('.search-terms').not($el).val(text);
    });

    var closeDropdown = function() {
      $('body').removeClass('is-active');
      $('.dropdown_link').removeClass('active_link');
      $('.dropdown_link').attr('aria-expanded', 'false');
      $('.dropdown_container').hide();
      $('.mobile_nav').find('div').removeClass('open');
    };

    var closeMiniCart = window.closeMiniCart = function($cart_container) {
      if(typeof $cart_container != 'undefined'){
        // Remove focus for keyboard navigation
        var $cart_container_mini = $cart_container.find('.js-cart_content__form');
        window.removeTrapFocus && window.removeTrapFocus($cart_container_mini[0]);
      }
      $('.cart_container').find('button.mini_cart_click_btn').attr('aria-expanded',false);
      $('.cart_container').find('button.mini_cart_click_btn').attr('tabindex','0');
      $('body').removeClass('is-active').removeClass('overflow-h');
      // $('.dropdown_link').toggleClass('active_link');
      $('.cart_container').removeClass('active_link');
    };

    var openMiniCart = window.openMiniCart = function($cart_container) {
      // Add focus for keyboard navigation
      var $cart_container_mini = $cart_container.find('.js-cart_content__form');
      window.trapFocus && window.trapFocus($cart_container_mini[0]);

      $('body').addClass('overflow-h');
      $('.mobile_nav div').removeClass('open');
      $('.dropdown_link').removeClass('active_link');
      $cart_container.find('button.mini_cart_click_btn').attr('aria-expanded',true);
      $cart_container.find('button.mini_cart_click_btn').attr('tabindex','-1');
      $cart_container.addClass('active_link');
    };

    $('.cart_content--backdrop').on('click', function(e) {
      if (e.target === e.currentTarget) {
        closeMiniCart();
      }
    });

    //Vertical menu enabled
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical, .vertical-menu_submenu').on('mouseover', function(e) {
        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        $('.active_link').removeClass('active_link');
        if(!$(this).hasClass('active_link')) {
          $(this).children('a').addClass('active_link');
          $('.is-absolute').parent().removeClass('feature_image');
        }
      });

      //Enable touch on parent link if on touch device and desktop menu is visible
      if(is_touch_device()){
        $('.vertical-menu .sublink a, .vertical-menu_submenu .sublink a').on('touchstart click', function(e) {
          e.stopPropagation();

          var verticalMenu = $(this);

          if(e.type == "touchstart") {
            clicked = true;
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else if(e.type == "click" && !clicked) {
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else {
            clicked = false;
          }

          function openDropdown(verticalMenu) {

            var $dropdownMegaMenu = $(verticalMenu).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
            var $dropdownVertical = $(verticalMenu).next('.vertical-menu_submenu');
            var clickCount = $(verticalMenu).attr('data-click-count');

            $('.dropdown_link--vertical').not(verticalMenu).attr('data-click-count', 0);
            $('.dropdown_link--vertical').attr('data-no-instant', true);
            $('.dropdown_container').not('[data-dropdown="search"]').hide();

            $dropdownMegaMenu.show();
            $('.vertical-menu_submenu').removeClass('is-visible');
            $dropdownVertical.addClass('is-visible');

            //capture touch event
            if (e.type == 'touchstart'){
              clickCount++;
              $(verticalMenu).attr('data-click-count', clickCount);

              if (clickCount < 2){
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            }
          }
        });
      }
    }

    if ($('.promo_banner').length){
      var promo_banner = sessionStorage.getItem('promo_banner');

      if (promo_banner != 'dismiss') {
        $('body').addClass('promo_banner-show');
        $('.promo_banner').on('click', '.promo_banner-close', function(){
          $('body').removeClass('promo_banner-show');
          //Cookies.set('promo_banner', 'dismiss', { expires: 30 });
          sessionStorage.setItem('promo_banner', 'dismiss');
        });
      }
    }

    //offscreen check for menu
    $('.vertical-menu_submenu, .vertical-menu_sub-submenu').each(function() {
      if($(this).is(':off-right')) {
        $(this).addClass('vertical-menu--align-right');
      }
    });

    /* Click anywhere outside of dropdown to close */
    $('html').on('click', function(event) {
      if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {
        if ($(event.target).closest('.remove-product-modal').length && $('.cart_content').is(':visible') || $('.remove-product-modal.show') && $('.cart_content').is(':visible')) {
          return;
        } else {
          closeMiniCart();
          $('.active_link').removeClass('active_link');
        }
      }

      if (!$(event.target).closest('.dropdown_container').length && !$(event.target).is('.dropdown_link.active_link') && $('.dropdown').is(':visible')) {
        closeDropdown();
      }

    });

    //Click on newsletter mobile menu field closes the menu
    $('body').on("click", '.mobile_menu_newsletter', function() {
      closeDropdown();
    });

    $(window).on("scroll", function() {
      $("body").toggleClass('header-scrolled',window.scrollY > 200);
    });

    //Only apply on larger screen sizes
    if ($(window).width() > 1024) {
      if ($('.header').hasClass('header-fixed--true')){

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('.main_nav_wrapper.sticky_nav').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });
        
      } else {
        $('.header-fixed--true').removeClass('header-fixed--true');
        if ($('.main_nav_wrapper').length > 1) {
          $('.main_nav_wrapper').first().remove();
        }
      }

      if ($('img.primary_logo:visible')){
        $('.logo img', $(".feature_image .header")).attr('src', $('.logo img').data('src-home'));
      } else {
        $('.logo img').attr('src', $('.logo img').data('src'));
      }
    //Mobile menu
    } else {

        this.productStickyMobile();
      if ($('#header').hasClass('mobile_nav-fixed--true')){
        $('body').addClass('mobile_nav-fixed--true');

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('#header').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });
      } else {
        $('body').addClass('mobile_nav-fixed--false');
      }
    }

    //avoid cart_content duplicating
    if($('.cart_content').length <= 2) {
      $('#header .cart_container').append($('.cart_content').clone());
    }

    if ( is_touch_device() || $(window).width() <= 1024 ) {

      $('.dropdown_link').attr('data-no-instant', true);

      $('body').on('click', '.dropdown_link', function(e) {

        // Autofocus for search on mobile
        if($(this).hasClass('dropdown_link--search-mobile')){
            $('.header_search_form input[name="q"]').trigger('focus');
            $('.mobile_nav').addClass('open');
        }

        $('.nav a').removeClass('active_link');

        if ($('#header').is(':visible')) {
          var $dropdown = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')

            if(!$(this).hasClass('mini_cart')) {
              $('.cart_container').removeClass('active_link');
            }

        } else {

          if($(this).hasClass("icon-search")) {
            window.location = $(this).attr("href");
            return false;
          }

          var $dropdown = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
        }

        if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {
          $dropdown.hide();
          $('body').removeClass('is-active');
        } else {
          $('.dropdown_container').not('[data-dropdown="search"]').hide();
          if(!$(this).hasClass('cart_container')) {
            $('.is-absolute').parent().removeClass('feature_image');
          }
          $dropdown.show();
          $('body').addClass('is-active');
          if(!$(this).hasClass('dropdown_link--search-mobile')){
              $('.mobile_nav').find('div').removeClass('open');
          }
        }

        if ($dropdown.is(':visible')) {
          e.stopPropagation();
          return false;
        }
      });

      $('body').on("click", '.mobile_nav', function() {
        $(this).toggleClass('open');
      });

      //Toggle mini-cart with menu icon
      $(".mini_cart").on("click", function(e) {

        // Davines Theme Logic for mobile cart button

        if (is_touch_device() || $(window).width() <= 1024) {
            e.preventDefault();
            var myLink = $(this).attr('href');
            window.location.href = myLink;
            return false;
        }


        // Standard Turbo Theme logic
        var $cart_container = $(this).parent();
        if($cart_container.hasClass('active_link')) {
            closeMiniCart($cart_container);
        } else {
            openMiniCart($cart_container);
        }

      });

      $('.cart_content__continue-shopping').on('click', function(e){
        closeMiniCart();
      });


    } else {

      $(".nav a, .logo a").not(".cart_content a, .cart_container a, .top-level-menu__link").on("mouseenter", function() {
        if(!$(this).hasClass("active_link")) {
          $('.dropdown_container').not('[data-dropdown="search"]').hide();
          $('.active_link').removeClass('active_link');
          $('.is-absolute').parent().addClass('feature_image');
          closeMiniCart();
        }
      });

      // $('.main_nav, .top_bar').on("mouseleave", function() {
      //   if ( $(window).width() > 1024) {
      //     $('.dropdown_container').not('[data-dropdown="search"]').hide();
      //   }
      //   $('.active_link').not('.cart_container').removeClass('active_link');
      //   $('.is-absolute').parent().addClass('feature_image');
      //   $('body').removeClass('blocked-overflow');
      // });

      $('.dropdown_link, .dropdown_link--vertical').attr('data-click-count', 0);

      function addEscapeEvent(_this, action){
        if($(window).width() > 1024) {
          _this.addEventListener("keydown", (event) => eventCloseObject(event, _this));

          function eventCloseObject(event, element){
            if(event.code.toUpperCase() === 'ESCAPE'){
              action();
              element.removeEventListener("keydown", eventCloseObject);
            }
          }
        }
      }

      $('.dropdown_link--click').on('click', function(e) {
        e.preventDefault();
        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        $dropdown.toggle();
        this.classList.toggle('current');


        // Autofocus for search overlay
        if($dropdown.data('dropdown') == 'search'){
          var isOpen = this.classList.contains('current');
          this.setAttribute('aria-expanded',isOpen);
          this.setAttribute('tabindex',(isOpen)? '-1' : 0);

          $dropdown[0].setAttribute('aria-hidden',!isOpen);
          $dropdown[0].setAttribute('tabindex',(!isOpen)? '-1' : 0);

          const isKlevuSearchActive = (typeof klevu != 'undefined' && typeof klevu.searchEvents != 'undefined');

          if(isOpen){
            // Trap focus only for standard Shopify search, cannot be applied to Klevu
            if(!isKlevuSearchActive){
              window.trapFocus && window.trapFocus($dropdown[0],$dropdown.find('input[name="q"]'));
            } else{
              $dropdown.find('input[name="q"]').focus();
            }

          } else {
            // Trap focus only for standard Shopify search, cannot be applied to Klevu
            if(!isKlevuSearchActive) window.removeTrapFocus && window.removeTrapFocus($dropdown[0]);
          }

          var closeSearchBarEvent = function () {
            var this_btn = $(".dropdown_link--click.current[data-dropdown-rel='search']");
            this_btn.trigger('click');
            this_btn.trigger('focus');
          }
          addEscapeEvent($dropdown[0], closeSearchBarEvent);
        }

        return false;
      });

      $('.mini_cart_click_btn').on('click', function(e) {
        e.preventDefault();
        var $cart_container = $(this).parent();
        if($cart_container.hasClass('active_link')) {
            closeMiniCart();
            $('.active_link').removeClass('active_link');
        } else {
            openMiniCart($cart_container);

            var closeMiniCartEvent = function(){
              $('.mini_cart_click_btn.current').trigger('focus');
              closeMiniCart($cart_container);
            }

            addEscapeEvent($cart_container[0], closeMiniCartEvent);
        }
      });

      $('.minicart_close').on('click', function(e) {
        closeMiniCart($(e.target).closest('.cart_container'));
      });

      // Hover intent (delayed hover) on First Level Desktop menu items
      $('.top-level-menu__link').hoverIntent({
        timeout: 200, // Timeout on hover
        interval: 350, // milliseconds hoverIntent waits between reading/comparing mouse coordinates.
        over: function() { 

          var hasMegamenu = $(this).hasClass('megamenu_link');

          var $megamenuAll = $(this).parents('.main_nav').find('.mega-menu');
          var $dropdown = $megamenuAll.filter('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
          
          // Close all megamenus
          $megamenuAll.hide();

          // Open related megamenu if needed
          if(hasMegamenu) $dropdown.show();
        },
        out: function() {
          // Don't need mouseout as we use other items mouseover and main_nav mouseout
        }
      });

      // main_nav mouseout
      $('.main_nav').hoverIntent({
        timeout: 1000,
        over: function(){},
        out: function(){
          $(this).find('.mega-menu').hide();
        }
      });

      // Megamenu for keyboard navigation
      $('.dropdown_link.megamenu_link').each((i,megaBtn) => {
       
        megaBtn.addEventListener("keydown", (event) => {

          const that = event.target;
          
          if(event.code.toUpperCase() === 'ENTER' ){
            
            const $dropdown = $(that).parents('.main_nav').find('[data-dropdown="' + $(that).data('dropdown-rel') + '"]');

            if(!$(that).hasClass('active_link')) {
              // Open mega menu
              $dropdown.show();
              $(that).addClass('active_link');
              that.setAttribute('aria-expanded', 'true');

              // Attach listeners for megamenu keyboard navigation
              that.addEventListener("keydown", (event) => megamenuTrapFocus(event, that, $dropdown));
              $dropdown[0].addEventListener("keyup", (event) => megamenuClose(event, that, $dropdown));
            
            } else {

              // Close mega menu
              $(that).removeClass('active_link');
              that.setAttribute('aria-expanded', 'false');
              $dropdown.hide();
              closeDropdown();
            }

          }


          function megamenuTrapFocus(event, element,dropdown) {
            if(event.code.toUpperCase() === "TAB") {
              window.trapFocus && window.trapFocus(dropdown[0]);
              element.removeEventListener("keydown", megamenuTrapFocus);
            }
          }
  
          function megamenuClose(event, element, dropdown) {
            if(event.code.toUpperCase() === "ESCAPE") {
              closeDropdown();
              window.removeTrapFocus && window.removeTrapFocus(element);
              dropdown[0].removeEventListener("keyup", megamenuClose);
            }
          }
  


        });
       



        

      });

      $('.dropdown_link:not(.megamenu_link)').on('mouseover touchstart', function(e) {

        /* Custom behaviors for dropdowns on click */
        if($(this).hasClass('dropdown_link--click')){
          return false;
        }

        /* Autofocus for search on desktop */
        if($(this).hasClass('dropdown_link--search')){
          $('.header_search_form input[name="q"]').trigger('focus');
        }

        if ($(window).width() > 1024) {
          $('.dropdown_container').not('[data-dropdown="search"]').hide();
        }

        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        function closeOtherMegamenu(clickedElement) {
          const elements = document.querySelectorAll(`.dropdown_link`);
          elements.forEach((element) => {
            if (element !== clickedElement) {
              element.classList.remove('active_link');
              element.setAttribute('aria-expanded', 'false');
            }
          });
        }

        closeOtherMegamenu(this);

        if(!$(this).hasClass('active_link')) {
          $dropdown.show();
          this.setAttribute('aria-expanded', 'true');

          this.addEventListener("keydown", (event) => megamenuTrapFocus(event, this));
          $dropdown[0].addEventListener("keyup", (event) => megamenuClose(event, this));

          function megamenuTrapFocus(event, element) {
            if(event.code.toUpperCase() === "TAB") {
              window.trapFocus && window.trapFocus($dropdown[0]);
              element.removeEventListener("keydown", megamenuTrapFocus);
            }
          }

          function megamenuClose(event, element) {
            if(event.code.toUpperCase() === "ESCAPE") {
              closeDropdown();
              window.removeTrapFocus && window.removeTrapFocus(element);
              $dropdown[0].removeEventListener("keyup", megamenuClose);
            }
          }

          if($(this).hasClass('mini_cart')) {
            if($('body').hasClass('cart')) {
                return false;
            }
            $(this).parent('.cart_container').addClass('active_link');
            $('body').addClass('blocked-overflow');
          } else {
            if ( $(window).width() > 1024) {
              $(this).addClass('active_link');
            }
            $('.is-absolute').parent().removeClass('feature_image');
          }
        } else {
          closeDropdown();
        }

        /* Enable touch on parent link if on touch device and desktop menu is visible */
        if(is_touch_device()){
          $('.dropdown_link').not(this).attr('data-click-count', 0);
          $('.dropdown_link').attr('data-no-instant', true);

          /* capture touch event */
          if (e.type == 'touchstart'){
            clickCount++;
            $(this).attr('data-click-count', clickCount);

            if (clickCount < 2){
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        }

      });

    }

    this.klevuSearchEvents();
  },
  klevuSearchEvents: function () {
    const isKlevuSearchActive = (typeof klevu != 'undefined' && typeof klevu.searchEvents != 'undefined');
    if(!isKlevuSearchActive) return;
    const searchDropdowns = document.querySelectorAll('.main_nav [data-dropdown="search"], .dropdown_container[data-dropdown="menu"]');
    searchDropdowns.forEach((dropdown) => {
      const searchInput = dropdown.querySelector('input[name="q"]');
      if (!searchInput) return;
      searchInput.addEventListener('keydown', (event) => {
        if(event.key === 'Tab') {
          event.preventDefault();
          const klevuSearchArea = document.getElementById('klevuSearchingArea');
          if (klevuSearchArea) {
            const firstFocusableElement = window.getFocusableElements && window.getFocusableElements(klevuSearchArea)[0];
            window.trapFocus && window.trapFocus(klevuSearchArea, firstFocusableElement || klevuSearchArea);
          }
        }
      });
    });
  },
  productStickyMobile: function(){

    if(!this.productStickyMobileInitialized){

        var $el = $(".product_section_container .purchase-details__buttons");
        $('.product-sticky-form').addClass('active');
        if($el.length>0){
            var elHeight = $el.outerHeight();

            $('.product-sticky-form__mobile-btn-scroll').on('click',function(){
                $("form.shopify-product-form").submit();
                /* $('html,body').animate({
                    scrollTop: $('.product-info-container-wrap').offset().top
                  },'slow'); */
            });

            $el.waypoint(function(direction) {

                $('.product-sticky-form').toggleClass('active',(direction=='down'));
                $('.product-sticky-form .add_to_cart').prop('disabled',(direction=='down'));

            }, {
                offset: (elHeight*-1)
            });

            $el.waypoint(function() {

              $('.product-sticky-form').toggleClass('active');
              $('.product-sticky-form .add_to_cart').prop('disabled');

            }, {
              offset: '100%'
            });

            this.productStickyMobileInitialized = true;
        }

    }
  },
  removeDataAttributes: function(target){
    if($(target).length){
      var i,
          $target = $(target),
          attrName,
          dataAttrsToDelete = [],
          dataAttrs = $target.get(0).attributes,
          dataAttrsLen = dataAttrs.length;

      for (i=0; i<dataAttrsLen; i++) {
        if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
          dataAttrsToDelete.push(dataAttrs[i].name);
        }
      }
      $.each( dataAttrsToDelete, function( index, attrName ) {
        $target.removeAttr( attrName );
      })
    }
  },
  loadMegaMenu: function(){

    //Remove old mega-menus so that theme-editor works properly
    $('.sticky_nav .mega-menu').remove();
    $('.header .mega-menu').remove();

    //Clone the mega menu from section into sticky_nav
    $('.mega-menu-container .mega-menu')
      .clone()
      .appendTo('.sticky_nav .main_nav');
    //Remove theme-editor data-attributes
    header.removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');

    //Loop through mega-menus to add arrow to parent
    $('.mega-menu-container .mega-menu').each(function(index){
      var megaMenuValue = $(this).data("dropdown");
      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .find('span')
        .remove();

      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .not('.icon-search')
        .append(' <span class="icon-down-arrow"></span>')
        .addClass('mega-menu-parent')
        .addClass('dropdown_link megamenu_link')
        .removeClass('top_link');

      $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
        if (!$(this).hasClass('mega-menu')) {
          $(this).remove();
        }
      });

      $(this).clone().appendTo('.header .main_nav');
    });

    //Remove default mega menus if vertical menus are selected
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu').remove();
      $('.dropdown_link--vertical:not(.mega-menu-parent)').each(function(index){
        var megaMenuValue = $(this).data('dropdown-rel');
        $('[data-dropdown="' + megaMenuValue + '"]').remove();
      })
    }

    // $('.mega-menu-parent').on('mouseenter', function() {

    //   if(!$(this).hasClass('active_link')) {
    //     $('.dropdown_container').not('[data-dropdown="search"]').hide();
    //     $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').toggle();

    //     $(this).addClass('active_link');
    //     $('.is-absolute').parent().removeClass('feature_image');

    //   }
    // });

    //Remove theme-editor data-attributes
    header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');

    if (is_touch_device() || $(window).width() <= 1024) {
      $('.dropdown_link').attr('data-no-instant', true);
    }

    header.loadMobileMegaMenu();
  },
  loadMobileMegaMenu: function() {

    //Loop through mega menus and add to mobile menu
    $('.mega-menu-container .mobile-mega-menu').each(function(index){
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a, [data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > button').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
        if (!$(this).hasClass('mobile-mega-menu')) {
          $(this).remove();
        }
      });
    });
  },
  unloadMegaMenu: function(){
    $('.header .mega-menu').remove();
    $('.mega-menu-container .mega-menu').each(function(index){
      var menuParent = $(this).data('dropdown');
      $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
    });
  },
  unload: function() {
    $('body').off('click', '.mobile_nav');
    $('body').off('click', '.dropdown_link');
    $('html').off('click');
    $('.mini_cart').off('click');
    $('.cart_content__continue-shopping').off('click');
    $('body').off('click', '.banner a[href^="#"]');
  }
}

/*============================================================================
  Social media
==============================================================================*/

  var social = {
    twitter: function(){
      if (!window.twttr){
        //Initialize twitter feed
        window.twttr = (function (d,s,id) {
        var t, js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
        js.src="https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });
        }(document, "script", "twitter-wjs"));
      }

      if (window.twttr) {
        window.twttr.ready(function (twttr) {
          twttr.widgets.load(
            document.getElementById("twitter-timeline")
          );
        });
      }
    },
    unload: function(){

    }
  }

  var instagram = {
    loadContent: function(s){
      if(s.clientID) {
        var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function(data) {

            if(data.meta.code === 200 && data.data.length) {
              var data = data.data;
              var count = 0;
              s.el.empty();

              for(var i = 0; i < data.length; i++) {
                var thisMedia = data[i], item;

                var url = thisMedia.images.low_resolution.url;

                if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                  item = '<div class="il-photo__img instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link">'+item+'</a>';
                }

                if(thisMedia.videos) {
                  item = '<div class="instagram__video instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link instagram__video-link">'+item+'</a>';
                }

                if(item) {
                  item = '<div class="'+s.column+ ' columns instagram__item small-down--one-whole">'+item+'</div>';
                }
                if(item !== '') {
                  s.el.append(item);
                  count++;
                }
                if(count == s.limit) {
                  break;
                }
              }
            }
          },
          error: function() {
          }
        });
      }
    }
  }

  $('.social-feeds-wrap').each(function (index, value) {

    social.twitter();

    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count'),
      column: $target.data('column')
    });
  });

/*============================================================================
  Map
==============================================================================*/
var mapFunction = {
  init: function() {

    if($('.lazymap').length > 0){
      lazyframe('.lazymap');
    }

    if ($('.maps').hasClass('js-api-map')) {
      var mapsToLoad = [];
      //Create map settings array
      $('.map').each(function(i, obj) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });
      $.each(mapsToLoad, function(i, instance) {
        //Enable caching to avoid duplicate google maps files
        $.ajaxSetup({ cache: true });
        //Load maps script and find location coordinates
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey
        ).then(function() {
          mapFunction.findLocation(mapsToLoad[i]);
          $.ajaxSetup({ cache: false });
        });
      });
    }
  },
  findLocation: function(mapArray) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder();
    //Find and set coordinates
    geocoder.geocode({ address: mapArray.address }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng();
        //Create map
        mapFunction.initMap(geoLat, geoLng, mapArray);
      } else {
        console.log('Error:' + status);
      }
    });
  },
  initMap: function(lat, lng, mapArray) {
    var location = { lat: lat, lng: lng };
    var styleJson = [];
    //Set style JSON
    if(mapArray.mapstyle=='aubergine'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#1d2c4d'}]},{elementType:'labels.text.fill',stylers:[{color:'#8ec3b9'}]},{elementType:'labels.text.stroke',stylers:[{color:'#1a3646'}]},{featureType:'administrative.country',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#64779e'}]},{featureType:'administrative.province',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'landscape.man_made',elementType:'geometry.stroke',stylers:[{color:'#334e87'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#023e58'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#283d6a'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#6f9ba5'}]},{featureType:'poi',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#023e58'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#3C7680'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#304a7d'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'road',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#2c6675'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#255763'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#b0d5ce'}]},{featureType:'road.highway',elementType:'labels.text.stroke',stylers:[{color:'#023e58'}]},{featureType:'transit',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'transit',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'transit.line',elementType:'geometry.fill',stylers:[{color:'#283d6a'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#3a4762'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#0e1626'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#4e6d70'}]}]
    }else if(mapArray.mapstyle=='retro'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#ebe3cd'}]},{elementType:'labels.text.fill',stylers:[{color:'#523735'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f1e6'}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#c9b2a6'}]},{featureType:'administrative.land_parcel',elementType:'geometry.stroke',stylers:[{color:'#dcd2be'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#ae9e90'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#93817c'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#a5b076'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#447530'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#f5f1e6'}]},{featureType:'road.arterial',elementType:'geometry',stylers:[{color:'#fdfcf8'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#f8c967'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#e9bc62'}]},{featureType:'road.highway.controlled_access',elementType:'geometry',stylers:[{color:'#e98d58'}]},{featureType:'road.highway.controlled_access',elementType:'geometry.stroke',stylers:[{color:'#db8555'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#806b63'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'transit.line',elementType:'labels.text.fill',stylers:[{color:'#8f7d77'}]},{featureType:'transit.line',elementType:'labels.text.stroke',stylers:[{color:'#ebe3cd'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'water',elementType:'geometry.fill',stylers:[{color:'#b9d3c2'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#92998d'}]}]
    }else if(mapArray.mapstyle=='silver'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#f5f5f5'}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f5f5'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#bdbdbd'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},{featureType:'road.arterial',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#dadada'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#c9c9c9'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]}]
    }else if(mapArray.mapstyle=='night'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#242f3e'}]},{elementType:'labels.text.fill',stylers:[{color:'#746855'}]},{elementType:'labels.text.stroke',stylers:[{color:'#242f3e'}]},{featureType:'administrative.locality',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#263c3f'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#6b9a76'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#38414e'}]},{featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#212a37'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#9ca5b3'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#746855'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#1f2835'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#f3d19c'}]},{featureType:'transit',elementType:'geometry',stylers:[{color:'#2f3948'}]},{featureType:'transit.station',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#17263c'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#515c6d'}]},{featureType:'water',elementType:'labels.text.stroke',stylers:[{color:'#17263c'}]}]}else{styleJson=[]}
    //Create google maps link
    $('.js-map-link').attr(
      'href',
      'https://www.google.com/maps/place/' +
        mapArray.directions +
        '/@' +
        lat +
        ',' +
        lng
    );
    //Set map options
    var mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false
    };
    //Create map
    var map = new google.maps.Map(
      document.getElementById(mapArray.sectionid),
      mapOptions
    );
    //Show pin
    if (mapArray.showpin == true) {
      var marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }
  }
};

/*============================================================================
  FAQ
==============================================================================*/
var faqAccordion = {
  init: function(){
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    $('.faqAccordion > dd').attr('aria-hidden',true);
    $faqHeading.attr('aria-expanded',false);
    $faqHeading.on('click activate',function(){
      if( flg ) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){
        flg = 0;
      });
        $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });
    $faqHeading.on('keydown',function(event){
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });
  }
}

/*============================================================================
  ADA aria-expanded
==============================================================================*/

document.addEventListener('DOMContentLoaded', function () {
  const cartButton = document.querySelector('.cart_container.dav-minicart .mini_cart_click_btn');

  if (cartButton) {
      // Aggiungi un listener per gestire l'evento keydown e simulare il click su "Enter" o "Space"
      cartButton.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              cartButton.click();
          }
      });
  }

  window.handleFocusCssClasses();
});

/* Prevent Conflict of Jquery libraries */
var $= jQuery.noConflict();
